import {FormHelperText, Button, Grid, TextField,MenuItem, Checkbox, FormControlLabel, Select } from '@mui/material';
import {React, useEffect, useState, useContext} from 'react'
import { useFormik } from 'formik';
import * as yup from 'yup';
import axios from "axios";
import { useUrlContext } from '../context/urlContext';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAuth } from '../context/authContext';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { errorContext } from '../Components/ErrorDisplay';

// Scans fields (num_scans_allowed / scans_per_day) must be a non-negative integer.
// Blank / null / undefined / NaN / negative all normalise to 0 (the default,
// which means "no limit"). Guards against the server sending -1 and against a
// field being left blank when the promotion type changes.
function clampScans(value) {
    const n = Number(value);
    if (value === '' || value === null || value === undefined || Number.isNaN(n) || n < 0) return 0;
    return Math.floor(n);
}

// Parse a "YYYY-MM-DD" (or "YYYY-M-D", or an ISO "YYYY-MM-DDTHH:mm:ss") date
// string into a local Date, or null.
function parseYmd(str) {
    if (!str) return null;
    const datePart = String(str).split('T')[0].trim();
    const parts = datePart.split('-');
    if (parts.length < 3) return null;
    const y = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10) - 1;
    const d = parseInt(parts[2], 10);
    if (Number.isNaN(y) || Number.isNaN(m) || Number.isNaN(d)) return null;
    return new Date(y, m, d);
}

export default function PromotionForm(props)
{
    const { user } = useAuth();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { UrlHelperObj } = useUrlContext();
    const { notify, handleError } = useContext(errorContext);
    const[fromTime,setFromTime] = useState(null);
    const[toTime,setToTime] = useState(null);
    const[fromDate,setFromDate] = useState(null);
    const[toDate,setToDate] = useState(null);
    const[fileName,setFileName] = useState('');
    const[isAddOperation,setIsAddOperation] = useState(false);
    const[clubExpiryDate,setClubExpiryDate] = useState('');
    const dateTimeFieldWidth = isSmallScreen ? '100%' : '290px';
    const getBrandIdValue = () => props.BrandRow?.id || props.selectedRow?.brand_id || '';
    const assignedRawValue = props.selectedRow?.assigned
        ?? props.selectedRow?.is_assigned
        ?? props.selectedRow?.assigned_count
        ?? props.selectedRow?.assignment_count
        ?? props.selectedRow?.assignedCount
        ?? props.selectedRow?.Assigned;
    const assignedCount = Number(assignedRawValue);
    const isAssignedZero = assignedCount === 0;
    const isAssignedOne = assignedCount === 1;
    const isGeneralFieldEditEnabled = isAddOperation || isAssignedZero;
    const isInstructionsEditEnabled = isGeneralFieldEditEnabled || isAssignedOne;

    var default_type_Value = 2;    
    const[typeList,setTypeList]=useState([{id:2,name:"Gym"},{id:1,name:"Zoo"},{id:0,name:"General"}])
    const[recvValues,setRecvValues] = useState({ 
    id:'', name:'',
    brand_id:getBrandIdValue(),
    description:'',
    valid_from:'',
    valid_to:'',
    valid_from_time:'',
    valid_to_time:'',
    num_scans_allowed:'',
    scans_per_day:'',
    type:'',
    programid:'',
    promotion_text:'',
    instructions:'',
    valid_days:[0,0,0,0,0,0,0],
});
    
    function tenFunc(i){
        return(i<10?'0':'')+i;
    }
    function toUTCDateTimeString(newDate)
    {
        var monStr = tenFunc(newDate.getMonth()+1);
        var utcStr = newDate.getFullYear()+"-"+monStr+"-"
                        + tenFunc(newDate.getDate())+"T"+
                        tenFunc(newDate.getHours())
                        +":"
                        +tenFunc(newDate.getMinutes());
        return utcStr;
    }
    function getLocalDateTime(utcDate,utcTime)
    {
        if(!utcDate || !utcTime)
            return null;
        const dateParts = utcDate.split('-');
        const timeParts = utcTime.split(':');
        if(dateParts.length < 3 || timeParts.length < 2)
            return null;
        const year = Number(dateParts[0]);
        const month = Number(dateParts[1]) - 1;
        const day = Number(dateParts[2]);
        const hour = Number(timeParts[0]);
        const minute = Number(timeParts[1]);
        if(Number.isNaN(year) || Number.isNaN(month) || Number.isNaN(day) || Number.isNaN(hour) || Number.isNaN(minute))
            return null;
        return new Date(year, month, day, hour, minute, 0, 0);
    }
    useEffect(()=>{
        //getProgramList();
       if(props.selectedRow !== null )//&& valueLoaded === false)
       {
            console.log("Promotion Edit"+JSON.stringify(props.selectedRow));
            setFileName(props.selectedRow.image);
            var typeVar = 0;
          if(props.selectedRow.type === 2)
                typeVar = "Gym";
          else if(props.selectedRow.type === 1)
                typeVar="Zoo";
         else if(props.selectedRow.type === 0)
                typeVar="General";
                
            var tDate = "";
            var toDateTemp = null;
            var fromDateTemp = null;
            if(props.selectedRow.valid_from === null || 
                props.selectedRow.valid_to === null)
            {
                const d = new Date();
                tDate = d.toLocaleDateString();
                toDateTemp = getLocalDateTime(tDate,props.selectedRow.valid_to_time); 
                fromDateTemp = getLocalDateTime(tDate,props.selectedRow.valid_from_time); 
            }
            else{
                toDateTemp = getLocalDateTime(props.selectedRow.valid_to,props.selectedRow.valid_to_time); 
                fromDateTemp = getLocalDateTime(props.selectedRow.valid_from,props.selectedRow.valid_from_time); 
            } 
            setToTime( toDateTemp);
            setFromTime(fromDateTemp);

            setToDate( toDateTemp);
            setFromDate(fromDateTemp);
            
            props.selectedRow.valid_to_time = props.selectedRow.valid_to_time_str;
            props.selectedRow.valid_from_time = props.selectedRow.valid_from_time_str;
            props.selectedRow.valid_to = props.selectedRow.valid_to_date_str;
            props.selectedRow.valid_from = props.selectedRow.valid_from_date_str;
                      
            setRecvValues({
                id:props.selectedRow.id,
                name:props.selectedRow.name,
                brand_id:getBrandIdValue(),
                description:props.selectedRow.description,
                valid_from:props.selectedRow.valid_from,
                valid_to:props.selectedRow.valid_to,
                valid_from_time:props.selectedRow.valid_from_time,
                valid_to_time:props.selectedRow.valid_to_time,
                num_scans_allowed:props.selectedRow.num_scans_allowed,
                scans_per_day:props.selectedRow.scans_per_day,
                type:props.selectedRow.type,
                programid:props.selectedRow.programid || '',
                promotion_text:props.selectedRow.promotion_text,
                instructions:props.selectedRow.instructions,
                valid_days: (function() {
                    let vd = props.selectedRow.valid_days;
                    if (typeof vd === 'string') {
                        try { vd = JSON.parse(vd); }
                        catch(e) { vd = vd.split(',').map(Number); }
                    }
                    // server stores valid_days as a JSON object {"0":1,...}; normalise to a 7-element array
                    if (vd && typeof vd === 'object' && !Array.isArray(vd)) {
                        vd = Object.keys(vd).sort((a,b)=>Number(a)-Number(b)).map(k => Number(vd[k]));
                    }
                    if (Array.isArray(vd) && vd.length === 7) return vd.map(Number);
                    return [0,0,0,0,0,0,0];
                })(),
                
            });
            setIsAddOperation(false);
        }
        else
        {
            /*setToTime( new Date());
            setFromTime(new Date());

            setToDate( new Date());
            setFromDate(new Date());
*/
            const defaultFromTime = new Date();
            defaultFromTime.setHours(0, 0, 0);
            const defaultToTime = new Date();
            defaultToTime.setHours(23, 59, 0);
            
            setFromTime(defaultFromTime);
            setToTime(defaultToTime);
            setFileName("");
            setRecvValues({  
                id:'', name:'',
                brand_id:getBrandIdValue(),
                description:'',
                valid_from:'',
                valid_to:'',
                valid_from_time:'00:00',
                valid_to_time:'23:59',
                num_scans_allowed:'',
                scans_per_day:'',
                type:'',
                programid:'',
                promotion_text:'',
                instructions:'',
                // New promotion: default to all days selected (Select All checked).
                valid_days:[1,1,1,1,1,1,1],
            });
            setIsAddOperation(true);
        }

    },[props.selectedRow]);

    // Fetch this club's membership expiry date (scoped to the club via iId).
    // Membership promotions have their Valid To date fixed to it (not editable).
    // On any failure show a toast so the user knows why the date can't be set.
    useEffect(() => {
        if (!user?.issuerId) return;
        axios.get(UrlHelperObj.partnerUrlByIssuer(user.issuerId))
            .then(res => res.data)
            .then(data => {
                const list = Array.isArray(data) ? data : (data ? [data] : []);
                const club = list.find(c => String(c.id) === String(user.issuerId)) || list[0] || null;
                const expiry = club?.expiry_date ?? club?.expiryDate ?? club?.membership_expiry_date ?? '';
                setClubExpiryDate(expiry || '');
                if (!expiry) {
                    notify("Could not read this club's membership expiry date, so Membership promotions cannot set the Valid To date.", 'warning');
                }
            })
            .catch(err => handleError(err));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.issuerId]);
    
    /*useEffect(()=>{
        console.log("Change in tier"+recvValues.programid);
        
        if(recvValues.programid !== null ||
             recvValues.programid !== undefined || recvValues.programid !== '')
            getTierList(recvValues.programid);
    },[recvValues.programid])
   
    useEffect(()=>{
        console.log("Change in type"+recvValues.type);
        
   
    },[recvValues.type])*/

    const handleChangeInPromotionType = (e) =>{
        const typeValue = Number(e.target.value);
        // Set type together with the type-dependent fields in ONE setValues call.
        // (Two sequential setFieldValue calls validate against an inconsistent
        // snapshot - e.g. programid cleared while type is still the old value -
        // which left the form wrongly invalid when switching to Member offer.)
        const next = { ...formik.values, type: typeValue };
        if (typeValue === 2) {
            // Member offer: Template ID must be blank and is not editable.
            next.programid = "";
        }
        if (typeValue === 0) {
            // Membership: scans are fixed at 0 and not editable.
            next.num_scans_allowed = 0;
            next.scans_per_day = 0;
        }
        formik.setValues(next, true);
    }
    const handleChangeInTierId = (e) =>{
        formik.setFieldValue("tierid",e.target.value);
    }
    function parseDateValue(value)
    {
        if(!value)
            return null;
        const parsedDate = new Date(value);
        if(Number.isNaN(parsedDate.getTime()))
            return null;
        return parsedDate;
    }
    function parseTimeToMinutes(value)
    {
        if(!value || typeof value !== 'string' || value.indexOf(':') === -1)
            return null;
        const splitValue = value.split(':');
        const hours = Number(splitValue[0]);
        const minutes = Number(splitValue[1]);
        if(Number.isNaN(hours) || Number.isNaN(minutes))
            return null;
        return (hours * 60) + minutes;
    }
    /* const handleChangeInProgramId=(e)=>
    {
        console.log((e));
        
        formik.setFieldValue("programid",e.target.value);
        getTierList(e.target.value)
    }    */
    const validationSchema = yup.object({
        
        name: yup
            .string("AAA")
            .max(50, 'Name must be at most 50 characters')
            .required('Promotion Name is required'),
        type: yup
            .number()
            .required('Promotion type is required'),
        programid: yup
            .string()
            .test(
                'template-id-required',
                'Template ID is required',
                function(value){
                    const t = this.parent.type;
                    const n = (t === '' || t === null || t === undefined) ? null : Number(t);
                    // Required for Membership (0) and Public promotion (1); blank for Member offer (2).
                    if(n === 0 || n === 1)
                        return value !== undefined && value !== null && String(value).trim() !== '';
                    return true;
                }
            ),
        valid_days: yup
            .array()
            .test('valid-days-required', 'Select at least one valid day', (arr) => Array.isArray(arr) && arr.some(d => Number(d) === 1)),
        promotion_text:yup
            .string("AAA")
            .required("Promotion text is required"),
        description:yup
            .string("AAA")
            .required("description is required"),
        valid_to_time:yup
            .string("AAA")
            .required("valid to  time is required"),
        valid_to:yup
            .string("AAA")
            .required("Valid to date is required")
            ,
            
        valid_from:yup
            .string("AAA")
            .required("Valid from date is required")
            .test(
                'valid-from-before-valid-to',
                'Valid from date should be less than or equal to valid to date',
                function(value){
                    const { valid_to } = this.parent;
                    if(!value || !valid_to)
                        return true;
                    const fromDateValue = parseDateValue(value);
                    const toDateValue = parseDateValue(valid_to);
                    if(fromDateValue === null || toDateValue === null)
                        return true;
                    return fromDateValue.getTime() <= toDateValue.getTime();
                }
            )
            ,
        num_scans_allowed:yup
            .number()
            .integer()
            .required("num scans is required")
            .min(0, "Number of scans allowed must be 0 or positive"),
        scans_per_day:yup
            .number()
            .integer()
            .required("scans per day is required")
            .min(0, "Scans per day must be 0 or positive"),
        valid_days:yup
            .array()
            .of(yup.number().oneOf([0, 1]))
            .length(7, "Valid days must have exactly 7 values"),
        
        instructions:yup
            .string("AAA")
            .required("instructions is required"),
        valid_from_time:yup
            .string("AAA")
            .required("valid from time is required")
            .test(
                'valid-from-time-before-valid-to-time',
                'Valid from time must be less than valid to time',
                function(value){
                    const { valid_to_time } = this.parent;
                    if(!value || !valid_to_time)
                        return true;
                    const fromTimeInMinutes = parseTimeToMinutes(value);
                    const toTimeInMinutes = parseTimeToMinutes(valid_to_time);
                    if(fromTimeInMinutes === null || toTimeInMinutes === null)
                        return true;
                    return fromTimeInMinutes < toTimeInMinutes;
                }
            )
        
        
      },[['type','valid_to','valid_from']]);
   
    
    
    function tenFunc(i){
        return(i<10?'0':'')+i;
    }
    function handleChangeFromTime(e)
    {
        if(e === null)
            return;
        const fromTimeMinutes = (e.getHours() * 60) + e.getMinutes();
        const currentToTimeValue = formik.values.valid_to_time;
        const toTimeMinutes = parseTimeToMinutes(currentToTimeValue);
        if(toTimeMinutes !== null && fromTimeMinutes >= toTimeMinutes)
        {
            formik.setFieldTouched("valid_from_time",true,false);
            formik.setFieldError("valid_from_time","Valid from time must be less than valid to time");
            return;
        }
        setFromTime(e);
        var fromTimeStr = tenFunc(e.getHours())+":"+tenFunc(e.getMinutes());
        formik.setFieldValue("valid_from_time",fromTimeStr,true);
        formik.setFieldTouched("valid_from_time",true,false);
        if(formik.errors.valid_from_time)
            formik.setFieldError("valid_from_time",undefined);
    }
    function handleChangeToTime(e)
    {
        if(e === null)
            return;
        const toTimeMinutes = (e.getHours() * 60) + e.getMinutes();
        const currentFromTimeValue = formik.values.valid_from_time;
        const fromTimeMinutes = parseTimeToMinutes(currentFromTimeValue);
        if(fromTimeMinutes !== null && fromTimeMinutes >= toTimeMinutes)
        {
            formik.setFieldTouched("valid_to_time",true,false);
            formik.setFieldError("valid_to_time","Valid to time must be greater than valid from time");
            return;
        }
        setToTime(e);
        var toTimeStr = tenFunc(e.getHours())+":"+tenFunc(e.getMinutes());
        formik.setFieldValue("valid_to_time",toTimeStr,true);
        formik.setFieldTouched("valid_to_time",true,false);
        if(formik.errors.valid_to_time)
            formik.setFieldError("valid_to_time",undefined);
    }
    function handleChangeFromDate(e)
    {
        if(e === null)
            return;
        if(toDate !== null && e.getTime() > toDate.getTime())
        {
            formik.setFieldTouched("valid_from",true,false);
            formik.setFieldError("valid_from","Valid from date should be less than or equal to valid to date");
            return;
        }
        setFromDate(e);
        var fromDateStr = e.getFullYear()+"-"+(parseInt(e.getMonth())+1)+"-"+tenFunc(e.getDate());
        console.log("from date:"+fromDateStr);
        formik.setFieldValue("valid_from",fromDateStr,true);
        formik.setFieldTouched("valid_from",true,false);
        if(formik.errors.valid_from)
            formik.setFieldError("valid_from",undefined);
    }
    function handleChangeToDate(e)
    {
        if(e === null)
            return;
        if(fromDate !== null && e.getTime() < fromDate.getTime())
        {
            formik.setFieldTouched("valid_to",true,false);
            formik.setFieldError("valid_to","Valid to date should be greater than or equal to valid from date");
            return;
        }
        setToDate(e);
        var toDateStr = e.getFullYear()+"-"+(parseInt(e.getMonth())+1)+"-"+tenFunc(e.getDate());
        formik.setFieldValue("valid_to",toDateStr,true);
        formik.setFieldTouched("valid_to",true,false);
        if(formik.errors.valid_to)
            formik.setFieldError("valid_to",undefined);
    }
    function onCancelForm()
    {
        //alert("Cancel");
        props.handleSubmit(null,isAddOperation,true)
    }
    const formik = useFormik({
        enableReinitialize:true,
        validateOnMount:true,
        validationSchema: validationSchema,
        initialValues:{
            id:recvValues?.id || '',
            brand_id:recvValues?.brand_id || getBrandIdValue(),
            name:recvValues?.name || '',
            description:recvValues?.description || '',
            valid_from:recvValues?.valid_from || '',
            valid_to:recvValues?.valid_to || '',
            valid_from_time:recvValues?.valid_from_time || '',
            valid_to_time:recvValues?.valid_to_time || '',
            num_scans_allowed: clampScans(recvValues?.num_scans_allowed),
            scans_per_day: clampScans(recvValues?.scans_per_day),
            type:recvValues?.type ?? '',
            programid:recvValues?.programid || '',
            promotion_text:recvValues?.promotion_text || '',
            instructions:recvValues?.instructions || '',
            valid_days:recvValues?.valid_days || [0,0,0,0,0,0,0],
            
        },

        onSubmit:(values, formikHelpers)=>{
           //console.log(values.image);
            //alert("Promotion"+JSON.stringify(values));
            formikHelpers.setSubmitting(true);
            if( values.valid_from_time === "" || values.valid_to_time === "" ||
            values.valid_from_time === null || values.valid_to_time === null)
            {
                notify("Please set both the valid-from and valid-to times.", 'error');
                formikHelpers.setSubmitting(false);
                return;
            }
            const fromTimeInMinutes = parseTimeToMinutes(values.valid_from_time);
            const toTimeInMinutes = parseTimeToMinutes(values.valid_to_time);
            if(fromTimeInMinutes !== null && toTimeInMinutes !== null && fromTimeInMinutes >= toTimeInMinutes)
            {
                notify("The valid-from time must be earlier than the valid-to time.", 'error');
                formikHelpers.setSubmitting(false);
                return;
            }
            if(values.type === 0 || values.type === 1 || values.type === 2)
            {
                if( (values.valid_from === "" || values.valid_to === "") )
                {
                    notify("Please set both the valid-from and valid-to dates.", 'error');
                    formikHelpers.setSubmitting(false);
                    return;
                }
                if(fromDate === null || toDate === null)
                {
                    notify("Please set both the valid-from and valid-to dates.", 'error');
                    formikHelpers.setSubmitting(false);
                    return;
                }
                if(fromDate.getTime() > toDate.getTime())
                {
                    notify("The valid-from date must be on or before the valid-to date.", 'error');
                    formikHelpers.setSubmitting(false);
                    return;
                }

            }

            
            
            
            if(values.name === '')
            {
                props.handleSubmit(null,isAddOperation,true);
                formikHelpers.setSubmitting(false);
                return;
            }

            values.valid_days = values.valid_days.map(v => v ? 1 : 0);
            values.type = Number(values.type);
            // Scans are always a non-negative integer (0 = no limit).
            values.num_scans_allowed = clampScans(values.num_scans_allowed);
            values.scans_per_day = clampScans(values.scans_per_day);
            if (values.type === 2) {
                values.programid = '';
            } else {
                values.programid = values.programid || '';
            }
            props.handleSubmit(values,isAddOperation,false);
            formikHelpers.setSubmitting(false);
        },
    });

    // Membership (type 0): Valid To date is fixed to the club's expiry date, and
    // Valid From is fixed to the current date (on add). Both are not editable.
    // Applies when selecting Membership and when editing an existing membership.
    useEffect(() => {
        if (Number(formik.values.type) !== 0) return;
        // Valid To = club expiry date.
        if (clubExpiryDate) {
            const d = parseYmd(clubExpiryDate);
            if (d) {
                const str = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + tenFunc(d.getDate());
                if (formik.values.valid_to !== str) {
                    formik.setFieldValue('valid_to', str, true);
                }
                setToDate(prev => (prev && prev.getTime() === d.getTime()) ? prev : d);
            }
        }
        // Valid From = current date on add (on edit keep the stored value).
        if (isAddOperation) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const fstr = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + tenFunc(today.getDate());
            if (formik.values.valid_from !== fstr) {
                formik.setFieldValue('valid_from', fstr, true);
            }
            setFromDate(prev => (prev && prev.getTime() === today.getTime()) ? prev : today);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clubExpiryDate, formik.values.type, isAddOperation]);

    // Scans fields: clamp negatives to 0 while typing; empty is allowed transiently
    // so the user can retype, then coerced back to 0 on blur. Never negative.
    const handleScansChange = (field) => (e) => {
        const raw = e.target.value;
        if (raw === '') { formik.setFieldValue(field, '', true); return; }
        let n = Number(raw);
        if (Number.isNaN(n)) return;
        if (n < 0) n = 0;
        formik.setFieldValue(field, Math.floor(n), true);
    };
    const handleScansBlur = (field) => (e) => {
        formik.setFieldValue(field, clampScans(formik.values[field]), true);
        formik.handleBlur(e);
    };

    const isSubmitDisabled = formik.isSubmitting || !formik.dirty || (isAddOperation && !formik.isValid);

    // Numeric promotion type (null when not yet selected). 0=Membership, 1=Public, 2=Member offer.
    const numericType = (formik.values.type === '' || formik.values.type === null || formik.values.type === undefined)
        ? null : Number(formik.values.type);
    const isMembership = numericType === 0;
    const isMemberOffer = numericType === 2;
    const isTemplateIdRequired = numericType === 0 || numericType === 1;

    return(
        // <Grid style={{ borderStyle: 'solid', borderColor: 'pink' }} container item spacing={3} xs={12}
        // direction="column" alignItems='flex-start' >
            // <Paper >
            <form onSubmit={formik.handleSubmit}  >
                {/* <Grid container spacing={2}> */}
                    <Grid item container xs={12} spacing={2}
                    justifyContent="flex-start" style={{ borderStyle: 'none', borderColor: 'black' }}
                    alignItems='flex-start' direction="row">
                {/* <Grid container spacing={{xs:2,md:5}} direction="row" columns={{xs:4,sm:8,md:12}}> */}
                            <Grid item xs={12} sm={12} md={12}  >
                            </Grid>
                            
                            <Grid item  xs={12} sm={4} md={4}  >
                                <TextField
                                    required
                                    fullWidth
                                    variant='outlined'
                                    id="name"
                                    disabled={!isGeneralFieldEditEnabled}
                                    name="name"
                                    label="Name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    inputProps={{ maxLength: 50 }}
                                    error={formik.touched.name && Boolean(formik.errors.name)}
                                    helperText={formik.touched.name && formik.errors.name}
                                />
                            </Grid>
                            <Grid item  xs={12} sm={4} md={4}  >
                                <TextField
                                required
                                fullWidth
                                variant='outlined'
                                    id="type"
                                    disabled={!isAddOperation}
                                    name="type"
                                    label="Promotion Type"
                                    select
                                    value={formik.values.type}
                                    onChange={handleChangeInPromotionType}
                                    error={formik.touched.type && Boolean(formik.errors.type)}
                                    helperText={formik.touched.type && formik.errors.type}
                                >
                                    <MenuItem value={0}>Membership</MenuItem>
                                    <MenuItem value={1}>Public promotion</MenuItem>
                                    <MenuItem value={2}>Member offer</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item  xs={12} sm={4} md={4}  >
                                <TextField
                                required={isTemplateIdRequired}
                                fullWidth
                                variant='outlined'
                                    id="programid"
                                    disabled={!isGeneralFieldEditEnabled || isMemberOffer}
                                    name="programid"
                                    label="Configured Template ID"
                                    value={formik.values.programid}
                                    onChange={formik.handleChange}
                                    error={formik.touched.programid && Boolean(formik.errors.programid)}
                                    helperText={(formik.touched.programid && formik.errors.programid) || 'Enter an already-configured template ID'}
                                />
                            </Grid>
                            <Grid item  xs={12} sm={6} md={6}  >
                                <TextField
                                required
                                fullWidth
                                variant='outlined'
                                    id="description"
                                    disabled={!isGeneralFieldEditEnabled}
                                    name="description"
                                    label="Promotion Description"
                                    value={formik.values.description}
                                    onChange={formik.handleChange}
                                    error={formik.touched.description && Boolean(formik.errors.description)}
                                    helperText={formik.touched.description && formik.errors.description}
                                />
                            </Grid>
                            <Grid item  xs={12} sm={6} md={6}  >
                                <TextField
                                required
                                fullWidth
                                variant='outlined'
                                    id="promotionText"
                                    disabled={!isGeneralFieldEditEnabled}
                                    name="promotion_text"
                                    label="Promotion Text"
                                    value={formik.values.promotion_text}
                                    onChange={formik.handleChange}
                                    error={formik.touched.promotion_text && Boolean(formik.errors.promotion_text)}
                                    helperText={formik.touched.promotion_text && formik.errors.promotion_text}
                                />
                            </Grid>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Grid item xs={12} sm={6} md={3}  >
                                <DatePicker
                                    label="Valid from date"
                                    value={fromDate}
                                    disablePast
                                    maxDate={toDate || undefined}
                                    inputFormat="dd/MM/yyyy"
                                    disabled={!isGeneralFieldEditEnabled || isMembership}
                                    onChange={handleChangeFromDate}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            required
                                            id="valid_from"
                                            name="valid_from"
                                            variant="outlined"
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            error={Boolean(formik.errors.valid_from)}
                                            helperText={formik.errors.valid_from}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}  >
                                <DatePicker
                                    label="Valid To Date"
                                    value={toDate}
                                    disablePast
                                    minDate={fromDate || undefined}
                                    inputFormat="dd/MM/yyyy"
                                    disabled={!isGeneralFieldEditEnabled}
                                    onChange={handleChangeToDate}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            required
                                            id="valid_to"
                                            name="valid_to"
                                            variant="outlined"
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            error={Boolean(formik.errors.valid_to)}
                                            helperText={formik.errors.valid_to}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <TimePicker
                                    ampm={false}
                                    label="Valid From Time"
                                    value={fromTime}
                                    disabled={!isGeneralFieldEditEnabled}
                                    onChange={handleChangeFromTime}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            required
                                            id="valid_from_time"
                                            name="valid_from_time"
                                            variant="outlined"
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            error={Boolean(formik.errors.valid_from_time)}
                                            helperText={formik.errors.valid_from_time}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                            <TimePicker
                                ampm={false}
                                label="Valid To Time"
                                value={toTime}
                                disabled={!isGeneralFieldEditEnabled}
                                onChange={handleChangeToTime}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        required
                                        id="valid_to_time"
                                        name="valid_to_time"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={Boolean(formik.errors.valid_to_time)}
                                        helperText={formik.errors.valid_to_time}
                                    />
                                )}
                            />
                            </Grid>
                            </LocalizationProvider>
                            {/* <Grid item xs={4} sm={4} md={4}>
                                <TextField
                                    fullWidth
                                    variant='outlined'
                                    id="valid_to_time"
                                    name="valid_to_time"
                                    label="Valid To Time"
                                    disabled={!isAddOperation}
                                    // defaultValue={formik.values.launch_date_time}
                                    value={formik.values.valid_to_time}
                                    type="time"
                                    onChange={formik.handleChange}
                                    InputLabelProps={{ shrink: true }}  
                                    error={formik.touched.valid_to_time && Boolean(formik.errors.valid_to_time)}
                                    helperText={formik.touched.valid_to_time && formik.errors.valid_to_time}
                                />
                            </Grid> */}
                            <Grid item  xs={12} sm={6} md={3} style={{alignSelf:'flex-start'}}>
                                <TextField
                                required
                                variant='outlined'
                                    id="num_scans_allowed"
                                    disabled={!isGeneralFieldEditEnabled || isMembership}
                                    name="num_scans_allowed"
                                    label="Total number of scans allowed "
                                    value={formik.values.num_scans_allowed}
                                    onChange={handleScansChange('num_scans_allowed')}
                                    onBlur={handleScansBlur('num_scans_allowed')}
                                    type="number"
                                    fullWidth
                                    inputProps={{ min: 0, max: 9999, step: 1 }}
                                    error={formik.touched.num_scans_allowed && Boolean(formik.errors.num_scans_allowed)}
                                    helperText={formik.touched.num_scans_allowed && formik.errors.num_scans_allowed}
                                />
                                 <FormHelperText id="num_scans_allowed">
                                   0 value implies no limit
                                </FormHelperText>
                            </Grid><Grid item  xs={12} sm={6} md={3} style={{alignSelf:'flex-start'}}>
                                <TextField
                                required
                                variant='outlined'
                                    id="scans_per_day"
                                    disabled={!isGeneralFieldEditEnabled || isMembership}
                                    name="scans_per_day"
                                    label="Scans per day"
                                    value={formik.values.scans_per_day}
                                    onChange={handleScansChange('scans_per_day')}
                                    onBlur={handleScansBlur('scans_per_day')}
                                    type="number"
                                    fullWidth
                                    inputProps={{ min: 0, max: 9999, step: 1 }}
                                    error={formik.touched.scans_per_day && Boolean(formik.errors.scans_per_day)}
                                    helperText={formik.touched.scans_per_day && formik.errors.scans_per_day}
                                />                                 <FormHelperText id="scans_per_day">
                                   0 value implies infinite scans per day
                                </FormHelperText>                            </Grid>
                            <Grid item  xs={12} sm={6} md={6} style={{alignSelf:'flex-start'}}>
                                <TextField
                                    required
                                    fullWidth
                                    variant='outlined'
                                    id="instructions"
                                    disabled={!isInstructionsEditEnabled}
                                    name="instructions"
                                    label="Instructions"
                                    value={formik.values.instructions}
                                    onChange={formik.handleChange}
                                    error={formik.touched.instructions && Boolean(formik.errors.instructions)}
                                    helperText={formik.touched.instructions && formik.errors.instructions}
                                />
                            </Grid>
                            <Grid item xs={12} style={{alignSelf:'flex-start'}}>
                                <FormHelperText style={{marginBottom: '8px'}}>
                                    Valid Days (Select which days the promotion is valid)
                                </FormHelperText>
                                <Grid container spacing={1}>
                                    <Grid item>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disabled={!isGeneralFieldEditEnabled}
                                                    checked={formik.values.valid_days.every(d => d === 1)}
                                                    indeterminate={formik.values.valid_days.some(d => d === 1) && !formik.values.valid_days.every(d => d === 1)}
                                                    onChange={(e) => {
                                                        const v = e.target.checked ? 1 : 0;
                                                        formik.setFieldValue('valid_days', [v, v, v, v, v, v, v]);
                                                    }}
                                                />
                                            }
                                            label="Select All"
                                        />
                                    </Grid>
                                    {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day, index) => (
                                        <Grid item key={index}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        disabled={!isGeneralFieldEditEnabled}
                                                        checked={formik.values.valid_days[index] ? true : false}
                                                        onChange={(e) => {
                                                            const newValidDays = [...formik.values.valid_days];
                                                            newValidDays[index] = e.target.checked ? 1 : 0;
                                                            formik.setFieldValue('valid_days', newValidDays);
                                                        }}
                                                    />
                                                }
                                                label={day}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                                {formik.errors.valid_days && (
                                    <FormHelperText error>{formik.errors.valid_days}</FormHelperText>
                                )}
                            </Grid>
                            
                            
                            
                            

                    </Grid>
                    <Grid container item xs={12}
                     direction="row" spacing={3}
                      style={{ borderStyle: 'none', borderColor: 'black' }} justifyContent='flex-start'>
                        <Grid item >
                            <Button
                                type='submit'
                                variant='contained'
                                color='primary'
                                disabled={isSubmitDisabled}
                                sx={{
                                    '&.Mui-disabled': {
                                        backgroundColor: '#bdbdbd !important',
                                        color: '#757575 !important',
                                        boxShadow: 'none'
                                    }
                                }}
                            >
                                Submit
                            </Button>
                            {/* {props.progress}
                            <CircularProgress variant="determinate" value={props.progress} /> */}
                        </Grid>
                        <Grid item>
                            <Button type='button' onClick={onCancelForm}  color='secondary' variant='contained'>Cancel</Button>
                        </Grid>
                    </Grid>
                {/* </Grid> */}
            </form>
            // </Paper>
        // </Grid>


    );
}
